import { Fields, Form2 } from "@cd2/forms"
import { useAsyncEffect } from "../../../hooks/useAsyncEffect"
import { IORBranchIRecord, orderRequestBranchAttributes } from "../../Branches/BranchesShowPage"
import React, { useEffect, useState } from "react"
import {
  IRmaBranch,
  IRmaContact,
  IRmaCustomer,
  rmaBranchAttributes,
  rmaContactAttributes,
  rmaCustomerAttributes,
} from "../RmasIndexPage"
import { useGlobalState } from "../../../Components/GlobalStateProvider"

export function InternalRmaBranchSelect({
  branchId,
  disabled,
}: {
  branchId?: string | null
  disabled?: boolean
}) {
  const { currentUser } = useGlobalState()
  const skeem = window.skeem
  const internalBranchField = Form2.useField<IORBranchIRecord | null>("internalRmaBranch", {
    subscribe: true,
  })
  const isInternalField = Form2.useField<boolean | null>("isInternal", { subscribe: true })
  const branchField = Form2.useField<IRmaBranch | null>("branch", { subscribe: true })
  const customerField = Form2.useField<IRmaCustomer | null>("customer", { subscribe: true })
  const contactField = Form2.useField<IRmaContact | null>("contact", { subscribe: true })

  async function assignDataFromSelection(internalRmaBranch?: IORBranchIRecord | null) {
    if (!internalRmaBranch) {
      branchField.setValue(null)
      customerField.setValue(null)
      return
    }

    
    const data = await skeem.fetch2<{
      branch: IRmaBranch
      customer: IRmaCustomer
      contact: IRmaContact | null
    }>({
      obj: {
        branch: {
          first: {
            name: "branches",
            matches: { id: internalRmaBranch.targetBranch.id },
            attributes: rmaBranchAttributes,
          },
        },
        customer: {
          first: {
            name: "customers",
            matches: { id: internalRmaBranch.customer.id },
            attributes: rmaCustomerAttributes,
          },
        },
      },
    })
    let { branch, customer } = data

    branchField.setValue(branch)
    customerField.setValue(customer)
  }

  useEffect(() => {
    internalBranchField.events.on(Form2.fieldEvents.change, () => {
      assignDataFromSelection(internalBranchField.getValue())
    })
    isInternalField.events.on(Form2.fieldEvents.change, () => {
      // clear the internal branch when changing state from TRUE -> FALSE
      if (!isInternalField.getValue()) {
        internalBranchField.setValue(null)
      }
    })
  }, [])

  const [internalRmaBranches, setInternalRmaBranches] = useState<IORBranchIRecord[] | null>(null)

  async function loadRecords() {
    if (!branchId) {
      setInternalRmaBranches(null)
      return
    }
    const branches = await skeem.fetch2<IORBranchIRecord[]>({
      model: {
        name: "orderRequestBranches",
        attributes: orderRequestBranchAttributes,
        matches: { sourceBranch: branchId },
      },
    })
    setInternalRmaBranches(branches)
  }

  useAsyncEffect(loadRecords, [branchId])

  Form2.useFormSubmitLock(() => {
    const value = internalBranchField.getValue()
    if (!value) {
      internalBranchField.setError("Branch is required")
      return false
    }
    internalBranchField.setError(undefined)
  })
  return (
    <Fields.Select2
      label="Branch order dispatched from"
      onChange={opt => internalBranchField.setValue(opt)}
      value={internalBranchField.getValue()}
      options={internalRmaBranches ?? []}
      isLoading={!internalRmaBranches}
      getOptionLabel={opt => opt.targetBranch.name}
      getOptionValue={opt => opt.id}
      validations={{ presence: true }}
      disabled={disabled}
      error={internalBranchField.getError()}
      showRequiredStar
    />
  )
}
